import Vue from "vue";
import sancionesTitularService from "../services/sancionesTitular.service";
import helper from "./helper";

export default {
    namespaced: true,
    state: {
        sanciones: [],
        estadosSanciones: [],
        sancion: null,
        selectedSancion: JSON.parse(localStorage.getItem('selectedSancion')) || null,
        expediente: null,
        archivos: null,
        acuerdoFirmado: null,
        userInfo: null,
        //Filtros
        buscar: null,
        estadoSeleccionado: null,
        // Parámetros de paginación
        per_page: 10,
        page: 1,
        last_page: 1,
    },
    getters: {
        getSanciones: (state) => state.sanciones,
        getSancion: (state) => state.sancion,
        getSelectedSancion: (state) => state.selectedSancion,
        getExpediente: (state) => state.expediente,
        getArchivos: (state) => state.archivos,
        getAcuerdoFirmado: (state) => state.acuerdoFirmado,
        getUserInfo: (state) => state.userInfo,
        getBuscar: (state) => state.buscar,
        getEstadoSeleccionado: (state) => state.estadoSeleccionado,
        getPagination: (state) => ({
            page: state.page,
            per_page: state.per_page,
            last_page: state.last_page,
        }),
    },
    mutations: {
        setSanciones(state, sanciones) {
            state.sanciones = sanciones;
        },
        setEstadosSanciones(state, estados) {
            state.estadosSanciones = estados;
        },
        setSancion(state, sancion) {
            state.sancion = sancion;
        },
        setSelectedSancion(state, sancion) {
            state.selectedSancion = sancion;
            localStorage.setItem('selectedSancion', JSON.stringify(sancion));
        },
        setExpediente(state, expediente) {
            state.expediente = expediente;
        },
        setArchivos(state, archivos) {
            state.archivos = archivos;
        },
        setAcuerdoFirmado(state, acuerdoFirmado) {
            state.acuerdoFirmado = acuerdoFirmado;
        },
        setUserInfo(state, userInfo) {
            state.userInfo = userInfo;
        },
        setBuscar(state, buscar) {
            state.buscar = buscar;
        },
        setEstadoSeleccionado(state, estado) {
            state.estadoSeleccionado = estado;
        },
        setPagination(state, pagination) {
            state.page = pagination.current_page;
            state.per_page = pagination.per_page;
            state.last_page = pagination.last_page;
        },
    },
    actions: {
        async fetchSanciones({ commit }, params) {
            try {
                const query = { page: params.page, per_page: params.per_page, sortDirection: 'asc' };
                const { data, status } = await sancionesTitularService.fetchSancionesTitular(query);
                if (status === 200) {
                    commit("setSanciones", data?.data?.sanciones);
                    commit("setUserInfo", data?.data?.userData);
                    commit("setPagination", data?.data?.meta);
                }
            } catch (error) {
                Vue.prototype.temporalAlert({
                    show: true,
                    type: "error",
                    message: error?.response?.data?.message || error?.response?.data?.error || 'Error al obtener las sanciones',
                });
                //console.error("Error al obtener las sanciones", error);
            }
        },
        async fetchEstados({ commit }) {
            try {
                const { data, status } = await sancionesTitularService.fetchEstadoSancion();
                if (status === 200) {
                    commit("setEstadosSanciones", data?.data);
                }
            } catch (error) {
                Vue.prototype.temporalAlert({
                    show: true,
                    type: "error",
                    message: error?.response?.data?.message || error?.response?.data?.error || 'Error al obtener los estados de sanciones',
                });
                //console.error("Error al obtener los estados de sanciones", error);
            }
        },
        async fetchSancionesFiltros({ commit }, params) {
            try {
                const query = {
                    page: params.page,
                    per_page: params.per_page,
                    search: params.search,
                    ...(params.id_estado && { estado: params.id_estado }),
                };
                const { data, status } = await sancionesTitularService.fetchSancionesTitular(query);
                if (status === 200) {
                    commit("setSanciones", data?.data?.sanciones);
                    commit("setPagination", data?.data?.meta);
                }
            } catch (error) {
                Vue.prototype.temporalAlert({
                    show: true,
                    type: "error",
                    message: error?.response?.data?.message || error?.response?.data?.error || 'Error al obtener las sanciones',
                });
                //console.error("Error al obtener las sanciones", error);
            }
        },
        async fetchSancionEmpleado({ commit }, id) {
            try {
                const { data, status } = await sancionesTitularService.fetchSancionEmpleado(id);
                if (status === 200) {
                    const { archivos } = data?.data || {};

                    const formatArchivos = {
                        adjuntos: helper.formatearArchivos(archivos?.adjuntos || []),
                        acta_justificacion: helper.formatearArchivos(archivos?.acta_justificacion || []),
                        resolucionExterna: helper.formatearArchivos(archivos?.resolucionExterna || []),
                        acuerdos: helper.formatearArchivos(archivos?.acuerdos || []),
                        acuerdo_firmado: helper.formatearArchivos(archivos?.acuerdo_firmado || []),
                    }

                    if (formatArchivos?.acuerdo_firmado?.length > 0) {
                        const { data, status } = await sancionesTitularService.getAcuerdoFirmado(formatArchivos.acuerdo_firmado[0]?.uuid);
                        if (status === 200) {
                            const acuerdo = {
                                nombre: formatArchivos.acuerdo_firmado[0]?.nombre,
                                uuid: formatArchivos.acuerdo_firmado[0]?.uuid,
                                url: data?.archivo
                            }
                            commit("setAcuerdoFirmado", acuerdo);
                        }
                    }

                    const { datosPersonales } = data?.data || {};
                    const { datosPlaza } = data?.data || {};
                    const formatDatosPersonales = {
                        ...datosPersonales,
                        tiempoServicio: datosPersonales.tiempoServicio?.formato_largo || null,
                    };
                    commit("setArchivos", formatArchivos);
                    commit("setExpediente", {
                        datosPersonales: formatDatosPersonales,
                        datosPlaza,
                    });
                    commit("setSancion", data?.data);
                }
            } catch (error) {
                Vue.prototype.temporalAlert({
                    show: true,
                    type: "error",
                    message: error?.response?.data?.message || error?.response?.data?.error || 'Error al obtener la sanción del empleado',
                });
                //console.error("Error al obtener la sanción del empleado", error);
            }
        },
        updateSelectedSancion({ commit }, sancion) {
            commit("setSelectedSancion", sancion);
        },
        resetSelectedSancion({ commit }) {
            commit("setSelectedSancion", null);
            localStorage.removeItem('selectedSancion');
        },
    },
};
